/**
 * Subscription plan type constants
 * These constants are used throughout the application to ensure consistency
 * and prevent typos when referring to subscription types
 */
export const PLAN_TYPE = {
  FREE: 'Free plan',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  CANCELED: 'canceled'
};
